import axios from 'axios';
import { ConfigModule } from '~/store/modules/config';

const httpService = axios.create({
    // time allowed before receiving an answer
    timeout: 30000,
});

httpService.interceptors.request.use(
    (reqConfig) => {
        if (ConfigModule.accessToken) {
            reqConfig.headers.authorization =
                'Bearer ' + ConfigModule.accessToken;
        }
        return reqConfig;
    },
    (error) => {
        /* Handle request error */
        Promise.reject(error);
    },
);

export default httpService;
